export default defineNuxtPlugin(() => {
  if ('serviceWorker' in navigator) {
    onNuxtReady(() => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('ServiceWorker registration successful:', registration.scope);
        })
        .catch((error) => {
          console.error('ServiceWorker registration failed:', error);
        });
    });
  }
});
